import { useState } from "react";
import { Form, Button } from 'reactstrap';
import { APILA } from "../../../../../../config/apila";
import Modal from 'react-bootstrap/Modal';
import { useMutation } from "react-query";
import "bulma/css/bulma.css";
import "../../../../../../index.css";
import ToastSuccess from "../../../../../NotificationToast/ToastSuccess";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faFloppyDisk } from '@fortawesome/free-solid-svg-icons';
import ToastError from "../../../../../NotificationToast/ToastError";

export default function ModalIndikatorAdd(props) {
  const token = localStorage.getItem("token");

  const [isSubmitting, setIsSubmitting] = useState(false);

  const id_user = localStorage.getItem("id_admin");
  const output_id_user = id_user.replace(/[|&;$%@"<>()+,]/g, "");

  let fetchParams = {
    headers : {"Authorization" : `${token}`,"Content-Type" : "application/json"}
  };

  const [form, setForm] = useState({
    id_element: "",
    description: "",
    user_id:"",
  });

  const handleChange = async (e) => {
    setForm({
      ...form,
      [e.target.name] : e.target.value,
    });
  };

  const handleSubmit = useMutation(async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await APILA.post("/api/sub-elements/store", {
        id_element: props.idelement,
        description: form?.description,
        user_id: output_id_user,
      }, fetchParams);

      if (response?.status === 200) {
        ToastSuccess.fire({
          icon: 'success',
          title: response.data.message,
        })
        props.GetResponseData();
        props.onHide();
      }
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title: error.response?.data?.message || "Gagal menyimpan data",
      });
    } finally {
      setIsSubmitting(false);
    }
  });

  return (
    <Modal
      {...props}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="sims-modal-dialog"
      contentClassName="sims-modal-content"
      aria-labelledby="modal-tambah-indikator"
    >
      <div className="sims-modal-header">
        <div>
          <h6 id="modal-tambah-indikator" className="sims-modal-title">
            Element {props.namaElement}
          </h6>
        </div>

        <button
          type="button"
          className="sims-modal-close"
          onClick={props.onHide}
          aria-label="Tutup modal"
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </div>

      <Form onSubmit={(event) => handleSubmit.mutate(event)}>
        <div className="sims-modal-body">

          <div className="mt-4 label-group-form" hidden>
            <label className="label-name-form">
               ID Element
             </label>
             <input className="label-input-form"  type='text' name="id_element" onChange={handleChange} value={form.id_element}  
               placeholder={props.idelement} disabled/>
             <style>{`input::placeholder { color: #B9B9B9;}`}
             </style>
          </div>

          <div className="sims-form-group">
            <label className="sims-form-label" htmlFor="indikator_add">
              Indikator <span>*</span>
            </label>
            
            <textarea
              id="indikator_add"
              className="sims-form-input pt-2"
              rows={6}
              style={{ minHeight: 140, resize: "vertical" }}
              name="description"
              value={form.description}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="sims-modal-footer">
          <button
            type="button"
            className="sims-modal-cancel"
            onClick={props.onHide}
            disabled={isSubmitting}
          >
            Batal
          </button>

          <button
            type="submit"
            className="sims-modal-submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <span className="sims-button-spinner" />
                Menyimpan...
              </>
            ) : (
              <>
                <FontAwesomeIcon icon={faFloppyDisk} />
                Tambahkan
              </>
            )}
          </button>
        </div>
      </Form>
    </Modal>
  );
}